import { Box, Grid, MenuItem, Select, TextField, Stack, Button, Autocomplete, Typography, Modal, TableContainer, Table, TableHead, TableCell, TableRow, TableBody, Paper } from '@mui/material';
import React, { useState, useEffect } from 'react'
import { DatePickerStyle, ErrorTypography, SecondaryTypography, StyledTypography } from '../../Theme';
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import { NameRegex, No_special_regex } from '../../Utils';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axiosInstance from '../../Redux/AxiosInstance';
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { DatePicker } from '@mui/x-date-pickers';
import { ReactComponent as DatePickerIcon } from "../../Icons/Datepicker.svg";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import moment from 'moment';
import dayjs from 'dayjs';
import PhoneInput from 'react-phone-input-2';
import * as XLSX from "xlsx";

function AddVisitor() {

    const navigate = useNavigate()
    const { userDetails } = useSelector((state) => state.Login);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const [openDatePicker1, setOpenDatePicker1] = useState(false);

    //(userDetails)
    const [uploadPreview, setUploadPreview] = useState([]);
    //(uploadPreview, 'uploadPreview')
    const initialDeviceData = {
        title: "",
        venue : "",
        description: "",
        invitors : [{
          name : "",
          email : "",
          phone : "",
          company_name : ""
        },],
        level: "",
        unit: "",
        accessstartdate: null,
        accessenddate: null,
    }
    const [PersonalDetailsData, setPersonalDetailsData] = useState({
        ...initialDeviceData
      });

      const {id} = useParams();
      const location = useLocation();
      const {deviceData} = location.state || {};

      useEffect(() => {
        if(id && deviceData){
            setPersonalDetailsData({
                name: deviceData.name || "",
                email: deviceData.email || "",
                phone: deviceData.phone || "",
                accessstartdate: deviceData.valid?.beginTime || null,
                accessenddate: deviceData.valid?.endTime || null,
            });
        }
      }, [id, deviceData]);

      //(deviceData)

      
      const [loading, setLoading] = useState(false)
      const [listBuilding, setListBuilding] = useState([])
      const [deviceList, setDeviceList] = useState([])
      const [selectedCompany, setSelectedCompany] = useState(null);

      const formatPhone = (phone = "") => {
  const trimmed = phone.trim();
  return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
};
      // const deviceList = [
      //     {
      //         id : 1,
      //         name : 'Facial Recognition (FR) & Quick Response (QR)',
      //     },
      //     {
      //         id : 3,
      //         name : 'Automatic Number Plate Recognition (ANPR)',
      //     }
      // ]

      const [errtext, seterrtext] = useState({
        PersonalDetailsData: {...initialDeviceData},
        invitors: [{}],
      });

      //(errtext, 'err')
      const getAllVisitors = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}company_list`)
          //(response)
          if(response.status === 200){
            setListBuilding(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          //(error, 'list devices')
          setLoading(false);
      }
  }

      const getDeviceTypes = async () => {
        setLoading(true)
      try {
          const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}list_purposes?is_web=false`)
          //(response)
          if(response.status === 200){
            setDeviceList(response.data.data);
          }
          setLoading(false);
      } catch (error) {
          //(error, 'list devices')
          setLoading(false);
      }
  }
  
    useEffect(() => {
      getAllVisitors();
      getDeviceTypes()
    }, []);

    //(deviceList)


   const handleFileUpload = (e) => {
   const input = e.target;
  const file = input.files[0];
  if (!file) return;

  const reader = new FileReader();

  reader.onload = (evt) => {
    const workbook = XLSX.read(evt.target.result, { type: "binary" });
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });

    if (!json.length) {
      alert("File is empty");
      return;
    }

    const headers = json[0].map(h => h.toString().trim().toLowerCase());

    const nameIdx = headers.indexOf("name");
    const emailIdx = headers.indexOf("email");
    const phoneIdx = headers.indexOf("phone");
    const companyIdx = headers.indexOf("company");

    if (nameIdx < 0 || emailIdx < 0) {
      alert("Name & Email columns are required");
      return;
    }

    const rows = [];

    for (let i = 1; i < json.length; i++) {
      const row = json[i];
      if (!row) continue;

      const name = row[nameIdx]?.toString().trim();
      const email = row[emailIdx]?.toString().trim();
      const company = row[companyIdx]?.toString().trim();
      const phone = phoneIdx !== -1 ? row[phoneIdx]?.toString().trim() : "";

      if (!name || !email) continue;

      rows.push({ name, email, phone: phone || "", company_name : company || "" });
    }

    // Max 50 preview rows
    setUploadPreview(rows.slice(0, 50));
    setIsModalOpen(true);

    input.value = "";
  };

  reader.readAsBinaryString(file);
};

const addPreviewRow = () => {
  if (uploadPreview.length >= 50) return;

  setUploadPreview(prev => [
    ...prev,
    { name: "", email: "", phone: "", company_name : "" }
  ]);
};

const updatePreviewRow = (index, field, value) => {
  setUploadPreview(prev => {
    const updated = [...prev];
    updated[index][field] = value;
    return updated;
  });
};

const removePreviewRow = (index) => {
  setUploadPreview(prev => prev.filter((_, i) => i !== index));
};

const applyExcelToInvitors = () => {
  setPersonalDetailsData((prev) => {
    // Only first 50
    const finalRows = uploadPreview.slice(0, 50);

    return {
      ...prev,
      invitors: finalRows.length
        ? finalRows
        : [{ name: "", email: "", phone: "", company_name : "" }]
    };
  });

  setIsModalOpen(false);
};


const handlePersonalDetails = (e, name) => {
  if (name) {
    let formattedValue = e;

    // Format only for date fields
    if (["accessstartdate", "accessenddate"].includes(name) && e) {
      // Create a new moment instance (avoid mutating the same object)
      formattedValue = moment(e.toDate ? e.toDate() : e)
        .format("YYYY-MM-DD");
    }

    setPersonalDetailsData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    seterrtext((prev) => ({
      ...prev,
      PersonalDetailsData: {
        ...prev.PersonalDetailsData,
        [name]: formattedValue ? "" : "This field is required",
      },
    }));

  } else {
    const { name, value } = e.target;
    setPersonalDetailsData((prev) => ({ ...prev, [name]: value }));
    seterrtext((prev) => ({
      ...prev,
      PersonalDetailsData: {
        ...prev.PersonalDetailsData,
        [name]: value.trim() === "" ? "This field is required" : "",
      },
    }));
  }
};

const handleInvitors = (index, key, value) => {
  const updatedInvitors = [...PersonalDetailsData.invitors];

  if (key === "phone") {
    updatedInvitors[index][key] = value ? `+${value}` : "";
  } else {
    updatedInvitors[index][key] = value;
  }

  setPersonalDetailsData((prev) => ({
    ...prev,
    invitors: updatedInvitors,
  }));

  // 🔹 Clear error immediately when user edits
  seterrtext((prev) => {
    const newErrors = [...(prev.invitors || [])];
    if (newErrors[index]) {
      newErrors[index][key] = "";
    }
    return { ...prev, invitors: newErrors };
  });
};

const addInvitor = () => {
  setPersonalDetailsData((prev) => {
    const maxLength = (userDetails?.user_role === 1 || userDetails?.user_role === 2) ? 50 : 50;

    if (prev.invitors.length >= maxLength) {
      // Optional: show a toast
      toast.error(`Invitation limit reached. Maximum ${maxLength} visitors can be invited at a time.`);
      return prev; // Do not update state
    }

    return {
      ...prev,
      invitors: [...prev.invitors, { name: "", email: "", phone: "", company_name : "" }],
    };
  });
};

const removeInvitor = (index) => {
  const updated = PersonalDetailsData.invitors.filter((_, i) => i !== index);

  setPersonalDetailsData((prev) => ({
    ...prev,
    invitors: updated,
  }));
};

const validateInvitors = () => {
  let isValid = true;

  const errors = PersonalDetailsData.invitors.map((item) => {
    let err = {};

    if (!item.name.trim()) {
      err.name = "Name is required";
      isValid = false;
    }

    if (!item.email.trim()) {
      err.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(item.email)) {
      err.email = "Invalid email address";
      isValid = false;
    }

    // if (!item.phone.trim()) {
    //   err.phone = "Phone is required";
    //   isValid = false;
    // } else if (!/^[0-9]{8,15}$/.test(item.phone)) {
    //   err.phone = "Invalid phone number";
    //   isValid = false;
    // }

    return err;
  });

  const emailCount = {};
  PersonalDetailsData.invitors.forEach((item, index) => {
    const email = item.email.toLowerCase().trim();
    if (email) {
      emailCount[email] = emailCount[email] ? [...emailCount[email], index] : [index];
    }
  });

  // ❌ Mark duplicates with error
  Object.values(emailCount).forEach((indexes) => {
    if (indexes.length > 1) {
      indexes.forEach((idx) => {
        errors[idx].email = "Email must be unique";
        isValid = false;
      });
    }
  });

   // ---------- UNIQUE PHONE CHECK (ONLY IF ENTERED) ----------
  const phoneMap = {};
  PersonalDetailsData.invitors.forEach((item, index) => {
    if (item.phone?.trim()) {
      const phone = item.phone.replace(/\D/g, "");
      phoneMap[phone] = phoneMap[phone]
        ? [...phoneMap[phone], index]
        : [index];
    }
  });

  Object.values(phoneMap).forEach((indexes) => {
    if (indexes.length > 1) {
      indexes.forEach((idx) => {
        errors[idx].phone = "Phone number must be unique";
        isValid = false;
      });
    }
  });

  seterrtext((prev) => ({ ...prev, invitors: errors }));
  return isValid;
};

//(PersonalDetailsData)
//(errtext)
useEffect(() => {
  if(userDetails.user_role == '5'){
      setPersonalDetailsData((prev) => ({
        ...prev,
        level: userDetails.level || "",
        unit: userDetails.unit || "",
      }));
  }
}, [userDetails])


const validatePersonalDetails = () => {
  const newErrors = {};

//   if (PersonalDetailsData.phone.trim().length > 0) {
//   // Only validate format if something is entered
//   if (!/^65\d{8}$/.test(PersonalDetailsData.phone)) {
//     newErrors.phone = "Enter a valid Singapore number (e.g. 65XXXXXXXX)";
//   }
// } else {
//   // No phone number entered — it's optional, so no error
//   newErrors.phone = "";
// }

if (!PersonalDetailsData.accessstartdate) {
  newErrors.accessstartdate = "Access start date is required";
}
if (!PersonalDetailsData.title) {
  newErrors.title = "Purpose of visit is required";
}

if (!PersonalDetailsData.accessenddate) {
  newErrors.accessenddate = "Access end date is required";
}

if(!selectedCompany && userDetails.user_role != '5'){
  newErrors.company = "Company selection is required";
}

  // Update the error state
  seterrtext((prev) => ({
    ...prev,
    PersonalDetailsData: {
      ...prev.PersonalDetailsData,
      ...newErrors,
    },
  }));

  // If no errors, return true
  return Object.keys(newErrors).length === 0;
};


useEffect(() => {
    setPersonalDetailsData((prev) => ({
      ...prev,
      accessenddate : null
    }))
}, [PersonalDetailsData.accessstartdate])

useEffect(() => {
  if (selectedCompany) {
    setPersonalDetailsData((prev) => ({
      ...prev,
      level: selectedCompany.level || "",
      unit: selectedCompany.unit || "",
    }));
  }
}, [selectedCompany]);

const downloadFile = async (fileName) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}download_file?file_name=${fileName}`,
      {
        responseType: "blob", // ⬅️ IMPORTANT for file download
      }
    );

    // Create a download link
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName; // suggested filename
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
  } catch (error) {
    //.error("Download failed:", error);
    alert("File download failed!");
  }
};


//(PersonalDetailsData)
      const saveDevice = async () => {
         if (validatePersonalDetails() && validateInvitors()) {
         
          setLoading(true)
          if(id){
             try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}company_update/${id}?updater_email=${userDetails?.email}`, {
                  ...PersonalDetailsData,
                  created_by : userDetails.user_role
              })
              //(response)
              if(response?.data?.status === 200){
                  //('created')
                  toast.success("Organization Updated Successfully")
                  setLoading(true)
                  setTimeout(() => {
                      navigate('/create_organization')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              //(error.response, 'saveDevice')
              if(error?.response?.status === 403 && error?.response?.data?.detail =="User not found" || error?.response?.data?.detail == "Access Denied"){
      localStorage.clear();
      window.location.href = "/login";
    }
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          } else {
            let obj ={}
            if(userDetails.user_role === 5){
                  obj = {name : PersonalDetailsData.name,
                  email : PersonalDetailsData.email,
                  phone : PersonalDetailsData.phone,
                  venue : PersonalDetailsData.venue,
                  description : PersonalDetailsData.description,
                  title : PersonalDetailsData.title,
                  level : PersonalDetailsData.level,
                  unit : PersonalDetailsData.unit,
                  invitors : PersonalDetailsData.invitors.map(invitor => ({
    name: invitor.name,
    email: invitor.email,
    phone: invitor.phone?.startsWith("+")
        ? invitor.phone
        : `+${invitor.phone}`,
    visitor_company: invitor.company_name,
  })),
                  valid : {
                    valid_from : PersonalDetailsData.accessstartdate,
                    valid_to : PersonalDetailsData.accessenddate,
                  },
                  created_by : userDetails.id,
                  role_id : userDetails.user_role,
                  company_id : userDetails.company_user_id || null
                }
            }else {
                  obj = {
                     name : PersonalDetailsData.name,
                    email : PersonalDetailsData.email,
                    phone : PersonalDetailsData.phone,
                    description : PersonalDetailsData.description,
                    venue : PersonalDetailsData.venue,
                    title : PersonalDetailsData.title,
                    level : PersonalDetailsData.level,
                    unit : PersonalDetailsData.unit,
                    invitors : PersonalDetailsData.invitors.map(invitor => ({
    name: invitor.name,
    email: invitor.email,
    phone: invitor.phone?.startsWith("+")
        ? invitor.phone
        : `+${invitor.phone}`,
    visitor_company: invitor.company_name,
  })),
                    valid : {
                      valid_from : PersonalDetailsData.accessstartdate,
                      valid_to : PersonalDetailsData.accessenddate,
                    },
                    created_by : userDetails.id,
                    role_id : userDetails.user_role,
                    company_id : selectedCompany?.id || null
                  }
            }
             try {
              const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}create_visitor?creator_email=${userDetails?.email}`, {
                 ...obj
              })
              //(response)
              if(response?.data?.status === 200){
                  //('created')
                  toast.success("Visitor Created Successfully")
                  setLoading(true)
                  setTimeout(() => {
                      navigate('/invite_visitor')
                  }, 1000)
                  
                  setPersonalDetailsData({...initialDeviceData})
              }
              setLoading(false)
          } catch (error) {
              //(error.response, 'saveDevice')
              if(error?.response?.status === 403 && error?.response?.data?.detail =="User not found" || error?.response?.data?.detail == "Access Denied"){
      localStorage.clear();
      window.location.href = "/login";
    }
              toast.error(error?.response?.data?.detail || "Something went wrong")
              setLoading(false)
          }
          }
         }
      }


  return (
      <>

      <ToastContainer
                  autoClose='5000'
                  position="bottom-center"
                  toastClassName="custom-toast"
                  hideProgressBar={true}
                />
    <Box
          mt={3}
          component="div"
        //   boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          {(userDetails.user_role == 1 || userDetails.user_role == 2 || userDetails.user_role == 5) && (
            <>
          <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2} px="16px" mt={2}>
            <Box sx={{display : 'flex', flexDirection : 'row', gap : 1, alignItems : 'center' }}>
  <Button variant="contained" component="label">
    Upload Excel / CSV
    <input
      type="file"
      hidden
      accept=".xlsx, .csv"
      onChange={handleFileUpload}
    />
  </Button>
  <Typography variant="body2" color="textSecondary">
    (Max 50 rows — Name & Email is required)
  </Typography>
  </Box>
  <Button variant="outlined" onClick={() => setIsModalOpen(true)} disabled={uploadPreview.length === 0}>
    Preview Uploaded Visitors
  </Button>
</Stack>
</>
)}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent={"space-between"}
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              mt : 3,
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <Box sx={{display : 'flex', flexDirection : 'row', gap : 1, alignItems : 'center' }}>
            <ContactDetailsIcon />
            <SecondaryTypography>Invite Visitor</SecondaryTypography>
            </Box>
            {(userDetails.user_role == 1 || userDetails.user_role == 2 || userDetails.user_role == 5) && (
              <Button
                variant="contained"
                onClick={() => downloadFile("sample_file.xlsx")}
              >
                Download Sample Excel
              </Button>
            )}
          </Stack>

          <Box sx={{maxHeight : '430px', minHeight : '430px',overflowY : 'scroll', backgroundColor : 'white'}}>

          {PersonalDetailsData?.invitors.map((invitor, index) => (
  <Grid
    container
    key={index}
    xs={12}
    gap="1%"
    sx={{
      backgroundColor: "white",
      padding: "10px 15px",
      borderBottom: "1px solid #E5E7EB",
      borderRadius: "0px",
    }}
  >
    {/* NAME */}
    <Grid xs={12} sm={3}>
      <StyledTypography>{index + 1}. Name as per ID*</StyledTypography>
      <TextField
        value={invitor.name}
        onChange={(e) => handleInvitors(index, "name", e.target.value)}
        inputProps={{ maxLength: 150 }}
        InputProps={{ disableUnderline: true }}
        sx={{
          "& .MuiInputBase-root": {
            color: errtext?.invitors[index]?.name ? "#912018" : "#111927",
          },
          backgroundColor: errtext?.invitors[index]?.name
            ? "#FEE4E2"
            : "#F9FAFB",
        }}
        fullWidth
      />
      <ErrorTypography>{errtext?.invitors[index]?.name}</ErrorTypography>
    </Grid>
    
    <Grid xs={12} sm={2}>
      <StyledTypography>Visitor's company</StyledTypography>
      <TextField
        value={invitor.company_name}
        onChange={(e) => handleInvitors(index, "company_name", e.target.value)}
        inputProps={{ maxLength: 200 }}
        InputProps={{ disableUnderline: true }}
        sx={{
          "& .MuiInputBase-root": {
            color: errtext?.invitors[index]?.name ? "#912018" : "#111927",
          },
          backgroundColor: errtext?.invitors[index]?.name
            ? "#FEE4E2"
            : "#F9FAFB",
        }}
        fullWidth
      />
      <ErrorTypography>{errtext?.invitors[index]?.name}</ErrorTypography>
    </Grid>

    {/* EMAIL */}
    <Grid xs={12} sm={2}>
      <StyledTypography>Email*</StyledTypography>
      <TextField
        value={invitor.email}
        onChange={(e) => handleInvitors(index, "email", e.target.value)}
        inputProps={{ maxLength: 100 }}
        InputProps={{ disableUnderline: true }}
        sx={{
          "& .MuiInputBase-root": {
            color: errtext?.invitors[index]?.email ? "#912018" : "#111927",
          },
          backgroundColor: errtext?.invitors[index]?.email
            ? "#FEE4E2"
            : "#F9FAFB",
        }}
        fullWidth
      />
      <ErrorTypography>{errtext?.invitors[index]?.email}</ErrorTypography>
    </Grid>

    {/* PHONE */}
    <Grid xs={12} sm={2}>
      <StyledTypography>Phone</StyledTypography>
      <Box sx={{mt : 1}}>
      <PhoneInput
                      value={invitor.phone}
                     
                      onChange={(value) => handleInvitors(index, "phone", value)}
                      inputProps={{  maxLength: 20 }}
                      country={"sg"}
                      buttonStyle={{ border: "none" }}
                      inputStyle={{
                        backgroundColor: errtext?.invitors[index]?.phone
                          ? "#FEE4E2"
                          : " #F9FAFB",
                        border: "none",
                        height: "46px",
                        width: "100%",
                        marginTop : "8px",
                        borderRadius: "8px",
                        color: errtext?.invitors[index]?.phone
                          ? "#912018"
                          : "#111927",
                      }}
                      // countryCodeEditable={false}
                      placeholder=""
                      specialLabel="" 
                    />
                    </Box>
      <ErrorTypography>{errtext?.invitors[index]?.phone}</ErrorTypography>
    </Grid>

    {/* ADD / REMOVE BUTTONS */}
    
    <Grid xs={12} sm={2.5} mt={4} sx={{display : 'flex', alignItems : 'start', justifyContent : 'flex-start'}}>
      
      {(PersonalDetailsData.invitors.length > 1) && (
        <Button onClick={() => removeInvitor(index)}><RemoveCircleOutlineIcon/></Button>
      )}
      {PersonalDetailsData.invitors.length === index + 1 && (
        <Button onClick={addInvitor}><AddCircleOutlineIcon /></Button>
    )}
    </Grid>
    
  </Grid>
))}
</Box>

<Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
              marginTop : "20px"
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Invitation Details</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px  ",
            }}
          >
            <Grid xs={12} sm={12}>
              <StyledTypography>Purpose of Visit</StyledTypography>
              <Autocomplete
  freeSolo
  options={deviceList || []}
  getOptionLabel={(option) =>
    typeof option === "string" ? option : option?.name || ""
  }
  isOptionEqualToValue={(option, value) =>
    option.name === value.name
  }
  value={
    deviceList.find((item) => item.name === PersonalDetailsData.title) ||
    PersonalDetailsData.title ||
    null
  }
  onChange={(event, newValue) => {
    // Selected from dropdown (object) OR typed value (string)
    const value = typeof newValue === "string" ? newValue : newValue?.name || "";
    handlePersonalDetails({
      target: { name: "title", value },
    });
  }}
  onInputChange={(event, newInputValue) => {
    handlePersonalDetails({
      target: { name: "title", value: newInputValue },
    });
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      name="title"
      inputProps={{
        ...params.inputProps,
        maxLength: 100,
      }}
      InputProps={{
        ...params.InputProps,
        disableUnderline: true,
      }}
      sx={{
        "& .MuiInputBase-root": {
          color: errtext.PersonalDetailsData?.title
            ? "#912018"
            : "#111927",
        },
        backgroundColor: errtext.PersonalDetailsData?.title
          ? "#FEE4E2"
          : "#F9FAFB",
      }}
      fullWidth
    />
  )}
/>
              <ErrorTypography>
                {errtext.PersonalDetailsData.title}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={12} mt={2}>
              <StyledTypography>Venue</StyledTypography>
              <TextField
                name="venue"
                value={PersonalDetailsData.venue}
                onChange={handlePersonalDetails}
                multiline
                rows={2}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 500 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.venue
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.venue
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.venue}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={12} mt={2}>
              <StyledTypography>Description</StyledTypography>
              <TextField
                name="description"
                value={PersonalDetailsData.description}
                onChange={handlePersonalDetails}
                multiline
                rows={3}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 500 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.description
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.description
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.description}
              </ErrorTypography>
            </Grid>

            {userDetails.user_role != '5' && (
            <Grid xs={12} sm={5.8} mt={2}>
                          <StyledTypography>Select Company*</StyledTypography>
                          <Autocomplete
                          // disabled={id ? true : false}
                  options={listBuilding}
                  getOptionLabel={(option) =>
                    `${option.company_name} | ${option.email}`
                  }
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" sx={{
        '& .MuiInputBase-root': {
          height: 36, // sets overall input height
        },
        '& .MuiInputBase-input': {
          padding: '0px 14px 14px 14px !important', // vertically centers text
        },
        backgroundColor: errtext.PersonalDetailsData.company
          ? "#FEE4E2"
          : " #F9FAFB",
      }} />
                  )}
                  onChange={(event, value) => {
                    setSelectedCompany(value)
                  seterrtext((prev) => ({
    ...prev,
    PersonalDetailsData: {
      ...prev.PersonalDetailsData,
      company: "",
    },
  }));
                  }}
                  value={selectedCompany}
                  sx={{ width: '100%', height : '46px' }}
                />
                          <ErrorTypography style={{marginTop: '20px'}}>
                            {errtext.PersonalDetailsData.company}
                          </ErrorTypography>
                        </Grid>
                         )}

            <Grid xs={12} sm={2.7} mt={2}>
              <StyledTypography>Level</StyledTypography>
              <TextField
                name="level"
                value={PersonalDetailsData.level}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.level
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.level
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.level}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={2.7} mt={2}>
              <StyledTypography>Unit</StyledTypography>
              <TextField
                name="unit"
                value={PersonalDetailsData.unit}
                onChange={handlePersonalDetails}
                // onKeyDown={(evt) => {
                //   !NameRegex.test(evt.key) && evt.preventDefault();
                // }}
                inputProps={{ maxLength: 20 }}
                InputProps={{ disableUnderline: true }}
                sx={{
                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.unit
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: errtext.PersonalDetailsData.unit
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                fullWidth
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.unit}
              </ErrorTypography>
            </Grid>

            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Access Start Date*</StyledTypography>
              <DatePicker
    //           open={openDatePicker}
    // onOpen={() => setOpenDatePicker(true)}
    // onClose={() => setOpenDatePicker(false)}
                format="DD/MM/YYYY"
                slots={{
                  openPickerIcon: () => <DatePickerIcon />,
                }}
                name="accessstartdate"
                value={
    PersonalDetailsData.accessstartdate
      ? dayjs(PersonalDetailsData.accessstartdate)
      : null
  }
  minDate={dayjs()}
  maxDate={dayjs().add(3, 'month')}
                onChange={(newValue) => handlePersonalDetails(newValue, "accessstartdate")}
                sx={{
                  ...DatePickerStyle,
                  backgroundColor: Boolean(
                    errtext.PersonalDetailsData.accessstartdate
                  )
                    ? "#FEE4E2"
                    : "",

                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.accessstartdate
                      ? "#912018"
                      : "#111927",
                  },
                }}
                 slotProps={{
      textField: {
        // onMouseEnter: () => setOpenDatePicker(true),
        // onMouseLeave: () => setOpenDatePicker(false),
      },
    }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.accessstartdate}
              </ErrorTypography>
            </Grid>
            <Grid xs={12} sm={5.8} mt={2}>
              <StyledTypography>Access End Date*</StyledTypography>
              <DatePicker
    //           open={openDatePicker1}
    // onOpen={() => setOpenDatePicker1(true)}
    // onClose={() => setOpenDatePicker1(false)}
                minDate={
  PersonalDetailsData.accessstartdate
    ? dayjs(PersonalDetailsData.accessstartdate)
    : dayjs() // default to today
}               
maxDate={dayjs(PersonalDetailsData.accessstartdate).add(1, 'month')}
                format="DD/MM/YYYY"
                slots={{
                  openPickerIcon: () => <DatePickerIcon />,
                }}
                name="accessenddate"
                value={
                    PersonalDetailsData.accessenddate
                      ? dayjs(PersonalDetailsData.accessenddate)
                      : null
                  }
                
                 onChange={(newValue) => handlePersonalDetails(newValue, "accessenddate")}
                sx={{
                  ...DatePickerStyle,
                  backgroundColor: Boolean(errtext.PersonalDetailsData.accessenddate)
                    ? "#FEE4E2"
                    : "",

                  "& .MuiInputBase-root": {
                    color: errtext.PersonalDetailsData.accessenddate
                      ? "#912018"
                      : "#111927",
                  },
                }}
                slotProps={{
      textField: {
        // onMouseEnter: () => setOpenDatePicker1(true),
        // onMouseLeave: () => setOpenDatePicker(false),
      },
    }}
              />
              <ErrorTypography>
                {errtext.PersonalDetailsData.accessenddate}
              </ErrorTypography>
            </Grid>
          </Grid>


<Box
          mt={3}
          component="div"
        //   boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          
          
            </Box>

            <Box bgcolor="#FFFFFF" sx={{ border: "1px solid #E5E7EB", borderRadius: '8px 8px 8px 8px', mt : 2 }}>
                <Stack direction="column" justifyContent='end' alignItems='end' sx={{ py : 2, px : 2, display: 'flex', gap : 2 , flexDirection : { xs : 'column', sm : 'row'} }}>
                    <Button type='button' onClick={() => navigate(-1)} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#f3eae7ff" }}>Back</Button>
                    <Button type='button' disabled={loading} onClick={() => saveDevice()} sx={{ fontWeight: '600', width: "100px", color: 'white', backgroundColor: "#800000", ":hover":{backgroundColor :"#800000"} }}>{id ? "Update" : "Create"}</Button>
                </Stack>
            </Box>
        </Box>

        <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "80%",
      bgcolor: "white",
      borderRadius: "12px",
      boxShadow: 24,
      p: 3,
      maxHeight: "80vh",
      overflowY: "auto",
    }}
  >
    <h3>Uploaded Visitors Preview</h3>

    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Company</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {uploadPreview.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>

              <TableCell>
                <TextField
                  value={row.name}
                  onChange={(e) => updatePreviewRow(index, "name", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  value={row.company_name}
                  onChange={(e) => updatePreviewRow(index, "company_name", e.target.value)}
                />
              </TableCell>

              <TableCell>
                <TextField
                  value={row.email}
                  onChange={(e) => updatePreviewRow(index, "email", e.target.value)}
                />
              </TableCell>

              <TableCell>
                <PhoneInput
  country={"sg"}
  value={row.phone}
  onChange={(phoneValue) => updatePreviewRow(index, "phone", phoneValue)}
  specialLabel=""
  inputStyle={{
    width: "100%",
    height: "40px",
    backgroundColor: "#F9FAFB",
    border: "0px solid #D0D5DD",
    borderRadius: "6px",
    fontSize: "14px",
    paddingLeft: "48px",
  }}
  buttonStyle={{
    border: "0px solid #D0D5DD",
    backgroundColor: "#F9FAFB",
    borderTopLeftRadius: "6px",
    borderBottomLeftRadius: "6px",
  }}
/>
              </TableCell>

              <TableCell>
                <Button
                  color="error"
                  onClick={() => removePreviewRow(index)}
                >
                  Remove
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Box display="flex" justifyContent="space-between" mt={2}>
      <Button onClick={addPreviewRow} disabled={uploadPreview.length >= 50}>
        Add Row
      </Button>

      <Box>
        <Button onClick={() => {
          setUploadPreview([])
          }} sx={{ mr: 1 }}>
          Clear
        </Button>
        <Button onClick={() => setIsModalOpen(false)} sx={{ mr: 1 }}>
          Cancel
        </Button>

        <Button variant="contained" onClick={applyExcelToInvitors}>
          Apply to Invitees
        </Button>
      </Box>
    </Box>
  </Box>
</Modal>
        </>
  )
}

export default AddVisitor